var map = {
	"./DnB - Etherid ALPHA (ZZZ DripFest 2024).mp3": 176,
	"./Electro - Arena Combat.mp3": 566,
	"./Electro - Zero Zeroes Left (ZZZ DripFest 2025).mp3": 929,
	"./Electro Funk - Like a Fire REMIX (Kensuke Ushio).mp3": 301,
	"./Epic Orchestral - Mindless Slaughter.mp3": 715,
	"./Glitch - TakeDisOut.mp3": 101,
	"./Jazz - Goofy Encounter.mp3": 13,
	"./Post Rock - Gate of the Sun.mp3": 965,
	"./Synthwave - Cityscape.mp3": 727,
	"./Synthwave - Cubic Symphony.mp3": 275
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 484;